import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'SLA (Service Level Agreement)',
  slug: 'sla',
  definition: `An SLA is a formal agreement between a service provider and its customers that defines the expected level of service availability. It specifies uptime targets, response times, and the consequences if those targets are not met.

Common SLA tiers include 99.9% (three nines, allowing about 8.7 hours of downtime per year), 99.99% (four nines, about 52 minutes per year), and 99.999% (five nines, about 5.26 minutes per year). Each additional nine dramatically reduces the allowable downtime.

SLAs often include financial penalties called service credits. If the provider fails to meet the agreed uptime target, the customer receives a discount or refund for the affected period.`,
  whyItMatters: `SLAs set clear expectations between you and your customers. Without one, there is no objective measure of whether your service reliability is acceptable. With one, both parties understand what "good enough" looks like.

For internal teams, SLAs drive engineering priorities. If you are at risk of breaching your SLA, that becomes the top priority. They also inform error budget calculations, helping teams balance feature development with reliability work.`,
  howUptrackHelps: `Uptrack tracks uptime percentages over any time window, making it straightforward to measure SLA compliance. You can see at a glance whether each monitor is meeting its uptime target.

With 30-second checks, Uptrack gives you precise downtime measurements. A 5-minute check interval can miss short outages entirely, making your SLA numbers look better than reality. Uptrack shows you the truth.`,
  relatedTerms: [
    { name: 'Uptime', href: '/glossary/uptime' },
    { name: 'Five Nines', href: '/glossary/five-nines' },
    { name: 'Error Budget', href: '/glossary/error-budget' },
    { name: 'Status Page', href: '/glossary/status-page' },
  ],
}

export const Route = createFileRoute('/_site/glossary/sla')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
